import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { GroupResourceSchema } from '../types/zod/groupResource';

const c = initContract();

export const groupResourceContract = c.router(
  {
    findById: {
      method: 'GET',
      path: `/resources/:resourceId`,
      pathParams: z.object({
        resourceId: z.string(),
      }),
      responses: { 200: GroupResourceSchema },
    },
    findByProperty: {
      method: 'GET',
      path: `/property/:propertyId/resources`,
      pathParams: z.object({
        propertyId: z.string(),
      }),
      responses: { 200: GroupResourceSchema.array() },
    },
    archive: {
      method: 'PUT',
      path: `/resources/:resourceId/archive`,
      pathParams: z.object({
        resourceId: z.string(),
      }),
      body: z.object({
        archived: z.boolean(),
      }),
      responses: { 200: GroupResourceSchema },
    },
    create: {
      method: 'POST',
      path: `/brand/:brandId/resource`,
      pathParams: z.object({
        brandId: z.string(),
      }),
      body: GroupResourceSchema.omit({ _id: true }).extend({
        brand: z.string(),
        resourceType: z.string(),
      }),
      responses: {
        200: GroupResourceSchema,
      },
    },
    update: {
      method: 'PUT',
      path: `/resources/:resourceId`,
      pathParams: z.object({
        resourceId: z.string(),
      }),
      body: GroupResourceSchema.extend({ resourceType: z.string() }).partial(),
      responses: {
        200: GroupResourceSchema,
      },
    },
    getResourcesAndTypes: {
      method: 'GET',
      path: `/brand/:brandId/resources-and-types`,
      pathParams: z.object({
        brandId: z.string(),
      }),
      responses: {
        200: z.object({
          resourceTypes: z.string().array(),
          resources: z.array(GroupResourceSchema),
        }),
      },
    },
  }
);
